import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import Transition from 'react-transition-group/Transition';

import { TabsSectionConsumer } from 'elements/Tabs/TabsSection/TabsSection';

import styles from './Container.css';

const Section = ({ indexKey, children }) => {
  const cx = classnames.bind(styles);
  const transitionStyles = {
    entering: { opacity: 0 },
    entered:  { opacity: 1 },
  };

  return (
    <TabsSectionConsumer>
      {({ activeTab }) => {
        const classes = cx(
          'section',
          'fade',
          {
            'active': indexKey === activeTab
          }
        );

        return (
          <Transition
            in={indexKey === activeTab}
            timeout={300}
            mountOnEnter
            unmountOnExit
            >
            {state => {
              return (
                <div
                  id={`tabsSection-container-${indexKey}`}
                  aria-labelledby={`tabsSection-tab-${indexKey}`}
                  className={classes}
                  style={{...transitionStyles[state]}}
                  data-key={indexKey}
                  role={'tab-container'}
                  aria-hidden={indexKey !== activeTab}
                >
                  {children}
                </div>
              );
            }}
          </Transition>
        );
      }}
    </TabsSectionConsumer>
  );
};

Section.propTypes = {
  children: PropTypes.node.isRequired,
  indexKey: PropTypes.number.isRequired
};

Section.displayName = 'Section';

export default Section;



// WEBPACK FOOTER //
// ./src/uis/elements/Tabs/TabsSection/Container/Container.js